import React, { useEffect, useRef } from 'react';
export const MessageList = ({ messages, isReplying }) => {
    const bottomRef = useRef(null);
    // Keep the latest message (or the typing indicator) in view.
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages.length, isReplying]);
    return (React.createElement("div", { "aria-live": "polite", className: "ai-assistant__messages", role: "log" },
        messages.length === 0 && !isReplying && (React.createElement("p", { className: "ai-assistant__empty" }, "Ask a question to get started.")),
        messages.map((message) => (React.createElement("div", { className: `ai-assistant__message ai-assistant__message--${message.role}`, key: message.id }, message.content))),
        isReplying && (React.createElement("div", { "aria-label": "Assistant is typing", className: "ai-assistant__message ai-assistant__message--assistant ai-assistant__typing" },
            React.createElement("span", { className: "ai-assistant__typing-dot" }),
            React.createElement("span", { className: "ai-assistant__typing-dot" }),
            React.createElement("span", { className: "ai-assistant__typing-dot" }))),
        React.createElement("div", { ref: bottomRef })));
};
